'use client';

import React from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import SolutionIcon1 from './icons/SolutionIcon1';
import SolutionIcon2 from './icons/SolutionIcon2';
import SolutionIcon3 from './icons/SolutionIcon3';
import SolutionIcon4 from './icons/SolutionIcon4';
import SolutionIcon5 from './icons/SolutionIcon5';

export default function Solutions() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
    <div className="w-full h-fit bg-base-white py-[120px] flex flex-col items-center justify-center">
      <div className="w-fit flex flex-col items-start justify-center gap-[80px]">
        <div className="flex flex-col items-start justify-center">
          <div className="font-display font-semibold text-xl leading-3xl text-cic-blue-500">
            {t('home.solutions.title', {})}
          </div>
          <div className="mt-l font-display font-semibold text-4xl leading-18xl text-primary tracking-[0%]">
            {t('home.solutions.description', {})}
          </div>
          <div className="mt-4xl font-regular text-xl leading-3xl text-gray-600">
            {t('home.solutions.description2', {})}
            <br />
            {t('home.solutions.description3', {})}
            <br />
            {t('home.solutions.description4', {})}
          </div>
        </div>
        <div className="flex flex-row items-start justify-center gap-[36px]">
          <div className="w-[403px] h-[198px] flex flex-col justify-start items-start gap-[16px] overflow-visible">
            <div className="w-[65.33px] h-[65.33px] shrink-0 flex items-center justify-center border-solid border-[9.33px] rounded-full border-cic-blue-50 bg-cic-blue-75">
              <SolutionIcon1 />
            </div>
            <div className="font-semibold text-xl leading-3xl text-primary">
              {t('home.solutions.high_performance_compute', {})}
            </div>
            <div className="font-regular text-md leading-xl text-gray-600">
              {t('home.solutions.high_performance_compute.description', {})}
            </div>
          </div>
          <div className="w-[403px] h-[198px] flex flex-col justify-start items-start gap-[16px]">
            <div className="w-[65.33px] h-[65.33px] shrink-0 flex items-center justify-center border-solid border-[9.33px] rounded-full border-cic-blue-50 bg-cic-blue-75">
              <SolutionIcon2 />
            </div>
            <div className="font-semibold text-xl leading-3xl text-primary">
              {t('home.solutions.optimized_ai_storage', {})}
            </div>
            <div className="font-regular text-md leading-xl text-gray-600">
              {t('home.solutions.optimized_ai_storage.description', {})}
            </div>
          </div>
          <div className="w-[403px] h-[198px] flex flex-col justify-start items-start gap-[16px]">
            <div className="w-[65.33px] h-[65.33px] shrink-0 flex items-center justify-center border-solid border-[9.33px] rounded-full border-cic-blue-50 bg-cic-blue-75">
              <SolutionIcon3 />
            </div>
            <div className="font-semibold text-xl leading-3xl text-primary">
              {t('home.solutions.rapid_experimentation', {})}
            </div>
            <div className="font-regular text-md leading-xl text-gray-600">
              {t('home.solutions.rapid_experimentation.description', {})}
            </div>
          </div>
        </div>
        <div className="flex flex-row items-start justify-start gap-[36px]">
          <div className="w-[403px] min-h-[198px] flex flex-col justify-start items-start gap-[16px]">
            <div className="w-[65.33px] h-[65.33px] shrink-0 flex items-center justify-center border-solid border-[9.33px] rounded-full border-cic-blue-50 bg-cic-blue-75">
              <SolutionIcon4 />
            </div>
            <div className="font-semibold text-xl leading-3xl text-primary">
              {t('home.solutions.broad_framework_support', {})}
            </div>
            <div className="font-regular text-md leading-xl text-gray-600">
              {t('home.solutions.broad_framework_support.description', {})}
            </div>
          </div>
          <div className="w-[403px] min-h-[198px] h-fit flex flex-col justify-start items-start gap-[16px]">
            <div className="w-[65.33px] h-[65.33px] shrink-0 flex items-center justify-center border-solid border-[9.33px] rounded-full border-cic-blue-50 bg-cic-blue-75">
              <SolutionIcon5 />
            </div>
            <div className="font-semibold text-xl leading-3xl text-primary">
              {t('home.solutions.real_time_performance_monitoring', {})}
            </div>
            <div className="font-regular text-md leading-xl text-gray-600">
              {t(
                'home.solutions.real_time_performance_monitoring.description',
                {}
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
